// extracted by mini-css-extract-plugin
export default {"separator":"SectionSeparator_separator__NfqjL","trait":"SectionSeparator_trait__FkC4r"};